import { useCallback } from 'react';
import DebugService from '../services/DebugService';

const getScopedKey = (key) => {
    const host = window.location.hostname;
    let prefix = 'dev';
  
    if (host.includes('staging')) {
      prefix = 'staging';
    } else if (host.includes('finops')) {
      prefix = 'prod';
    }
  
    return `${prefix}_${key}`;
  };
  

export const useScopedLocalStorage = () => {
  const setScopedItem = useCallback((key, value) => {
    const scopedKey = getScopedKey(key);
    const serialized = JSON.stringify(value);
    // JSON.stringify(undefined) returns undefined, which setItem would store as the
    // string "undefined" and break every later read of this key
    if (serialized === undefined) {
      localStorage.removeItem(scopedKey);
      return;
    }
    localStorage.setItem(scopedKey, serialized);
  }, []);

  const getScopedItem = useCallback((key) => {
    const scopedKey = getScopedKey(key);
    const item = localStorage.getItem(scopedKey);
    if (!item) return null;
    try {
      return JSON.parse(item);
    } catch (e) {
      // Corrupt/legacy value (e.g. the literal "undefined") - drop it so it can't keep throwing
      DebugService.error(`Failed to parse localStorage item "${scopedKey}"`, e);
      localStorage.removeItem(scopedKey);
      return null;
    }
  }, []);

  const removeScopedItem = useCallback((key) => {
    const scopedKey = getScopedKey(key);
    localStorage.removeItem(scopedKey);
  }, []);

  return {
    setScopedItem,
    getScopedItem,
    removeScopedItem,
  };
};
